import { pxToRem } from '../../utils';
var avatarStyles = {
    root: function (_a) {
        var size = _a.props.size;
        var sizeInRem = pxToRem(size);
        return {
            position: 'relative',
            backgroundColor: 'inherit',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: sizeInRem,
            width: sizeInRem,
        };
    },
    image: function () { return ({
        verticalAlign: 'top',
    }); },
    label: function (_a) {
        var size = _a.props.size;
        var sizeInRem = pxToRem(size);
        return {
            display: 'inline-block',
            width: sizeInRem,
            height: sizeInRem,
            lineHeight: sizeInRem,
            fontSize: pxToRem(size / 2.333),
            verticalAlign: 'top',
            textAlign: 'center',
            padding: '0px',
        };
    },
    status: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({
            position: 'absolute',
            bottom: "-" + variables.statusBorderWidth + "px",
            right: "-" + variables.statusBorderWidth + "px",
        });
    },
};
export default avatarStyles;
